import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Star, ThumbsUp, MessageCircle } from 'lucide-react';

interface Feedback {
  id: string;
  rating: number;
  comment: string;
  date: string;
  property: string;
}

const recentFeedback: Feedback[] = [
  {
    id: '1',
    rating: 5,
    comment: 'Excellent work on the HVAC maintenance. Very thorough and professional.',
    date: '2024-01-20',
    property: 'Building A'
  },
  {
    id: '2',
    rating: 4,
    comment: 'Good job with the plumbing repair. Quick response time.',
    date: '2024-01-19',
    property: 'Oak Residences'
  },
  {
    id: '3',
    rating: 5,
    comment: 'Outstanding service! Went above and beyond expectations.',
    date: '2024-01-18',
    property: 'Pine View'
  },
];

export function FeedbackSummaryCard() {
  const averageRating = recentFeedback.reduce((acc, curr) => acc + curr.rating, 0) / recentFeedback.length;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Feedback</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Star className="h-5 w-5 fill-primary text-primary" />
              <span className="text-2xl font-bold">{averageRating.toFixed(1)}</span>
              <span className="text-sm text-muted-foreground">
                average rating
              </span>
            </div>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-1">
                <ThumbsUp className="h-4 w-4 text-success" />
                <span className="text-sm font-medium">98% Positive</span>
              </div>
              <div className="flex items-center gap-1">
                <MessageCircle className="h-4 w-4 text-muted-foreground" />
                <span className="text-sm font-medium">
                  {recentFeedback.length} reviews
                </span>
              </div>
            </div>
          </div>

          <ScrollArea className="h-[300px]">
            <div className="space-y-4">
              {recentFeedback.map((feedback) => (
                <div
                  key={feedback.id}
                  className="rounded-lg border p-4 space-y-2"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-1">
                      {[...Array(5)].map((_, i) => (
                        <Star
                          key={i}
                          className={`h-4 w-4 ${
                            i < feedback.rating
                              ? 'fill-primary text-primary'
                              : 'fill-muted text-muted-foreground'
                          }`}
                        />
                      ))}
                    </div>
                    <span className="text-sm text-muted-foreground">
                      {feedback.date}
                    </span>
                  </div>
                  <p className="text-sm">{feedback.comment}</p>
                  <p className="text-sm text-muted-foreground">
                    {feedback.property}
                  </p>
                </div>
              ))}
            </div>
          </ScrollArea>
        </div>
      </CardContent>
    </Card>
  );
}